export const CORTEX_REQUIRED_MODEL_WORKLOADS = [
  'realtime_response',
  'background',
  'media',
  'transcription',
  'embeddings',
];
export const CORTEX_OPTIONAL_MODEL_WORKLOADS = ['decision'];
export const CORTEX_MODEL_WORKLOADS = [
  ...CORTEX_REQUIRED_MODEL_WORKLOADS,
  ...CORTEX_OPTIONAL_MODEL_WORKLOADS,
];

const activeCredentialConfigured = connection =>
  connection?.status === 'active' &&
  connection.credentials?.some(
    credential =>
      credential.status === 'active' && credential.api_key_configured
  );

export const hasReadyModelRoute = (settings, workload) => {
  const backendReadiness = settings?.model_readiness?.workloads?.[workload];
  if (backendReadiness) return backendReadiness.ready === true;

  const model = settings?.model || {};
  const route = model.model_routes?.find(
    item => item.workload === workload && item.status === 'active'
  );
  if (!route) return false;

  const connectionsById = new Map(
    (model.provider_connections || []).map(connection => [
      Number(connection.id),
      connection,
    ])
  );

  return route.targets?.some(target => {
    const connection = connectionsById.get(
      Number(target.provider_connection_id)
    );

    return (
      target.status === 'active' &&
      Boolean(target.model) &&
      activeCredentialConfigured(connection)
    );
  });
};

export const hasReadyModelConfiguration = settings =>
  CORTEX_REQUIRED_MODEL_WORKLOADS.every(workload =>
    hasReadyModelRoute(settings, workload)
  );

export const hasReadyHistoricalProcessing = settings => {
  const backendReadiness = settings?.model_readiness;
  if (backendReadiness) {
    return backendReadiness.historical_processing_ready === true;
  }

  return ['background', 'media', 'transcription', 'embeddings'].every(
    workload => hasReadyModelRoute(settings, workload)
  );
};
